<div class="flyout-referral-container">
  <div class="flyout-headline-row">
    <div class="headline-title">
      <span>{{ "widgets.campaigns.new-referral-btn" | translate }}</span>
    </div>
    <div class="header-close-icon">
      <mat-icon class="close-icon" (click)="cancelFlyout()">close</mat-icon>
    </div>
  </div>
  <div class="flyout-referral-settings">
    @if (loadingWidgetTemplates) {
      <div class="loading">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
    }
    @if (!loadingWidgetTemplates) {
      <mat-accordion class="component-flyout-accordion">
        <mat-expansion-panel [expanded]="accordionStep && accordionStep === 'nameReferral'" (opened)="setAccordionStep('nameReferral')">
          <mat-expansion-panel-header>
            <mat-panel-title class="wrapper-mat-panel-title">
              <span>{{ "referral-campaign.give-a-name-to-referral" | translate }}</span>
              @if (!campaignNameValidationError && getNameReferral) {
                <span class="done-wrapper">
                  <img src="../../../assets/img/green-check.svg" alt="" />
                  {{ "generic.done" | translate }}
                </span>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="name-container">
            <mat-form-field appearance="outline" floatLabel="always">
              <input
                matInput
                type="text"
                [(ngModel)]="nameReferral"
                [disabled]="!disabledFriends"
                name="name"
                required
                #nameInput="ngModel"
                (ngModelChange)="validateCampaignName()"
                placeholder="{{ 'referral-campaign.placeholder-example-for-name' | translate }}" />
              @if (campaignNameValidationError && !nameInput.untouched) {
                <mat-hint class="error">* {{ campaignNameValidationError | translate }}</mat-hint>
              }
            </mat-form-field>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="accordionStep && accordionStep === ReferralTypes.Referring" (opened)="setAccordionStep(ReferralTypes.Referring)">
          <mat-expansion-panel-header>
            <mat-panel-title class="wrapper-mat-panel-title">
              <span>{{ "referral-campaign.creating-referral" | translate }}</span>
              @if (!disabledFriends) {
                <span class="done-wrapper">
                  <img src="../../../assets/img/green-check.svg" alt="" />
                  {{ "generic.done" | translate }}
                </span>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p class="description">{{ "referral-campaign.description-referring" | translate }}</p>
          <p class="pick-template">{{ "referral-campaign.pick-referral-template" | translate }}</p>
          <div class="templates-container">
            <div class="templates-wrapper">
              @for (template of referringTemplates; track template) {
                <div
                  class="template-item-wrapper"
                  (click)="createCampaignFromTemplate(template.id, ReferralTypes.Referring)"
                  [matTooltip]="
                    !getNameReferral || campaignNameValidationError
                      ? ('campaign.warningNoName' | translate)
                      : !disabledFriends
                        ? ('campaign.warningExistingRef' | translate)
                        : null
                  ">
                  <div class="template-item">
                    <div class="template-item-img">
                      @if (template.previewImages.length === 1) {
                        <img
                          onError="this.src='/assets/img/campaign/thumbnail-darkmode.png'"
                          [src]="template && template.previewImages[0]?.url"
                          alt="Image Title" />
                      }
                    </div>
                    <div class="template-item-name">
                      <span>{{ template.name }}</span>
                    </div>
                    <div class="template-item-tags">
                      @for (tag of template.tagsDetails; track tag) {
                        <div class="tag-item">
                          <span>{{ tag.name }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="accordionStep && accordionStep === ReferralTypes.Friends" (opened)="setAccordionStep(ReferralTypes.Friends)">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ "referral-campaign.creating-friends" | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <p class="description">{{ "referral-campaign.description-friends" | translate }}</p>
          <p class="pick-template">{{ "referral-campaign.pick-referral-template" | translate }}</p>
          <div class="templates-container">
            <div class="templates-wrapper">
              @for (template of friendsTemplates; track template) {
                <div
                  class="template-item-wrapper"
                  (click)="createCampaignFromTemplate(template.id, ReferralTypes.Friends)"
                  [matTooltip]="
                    !getNameReferral || campaignNameValidationError
                      ? ('campaign.warningNoName' | translate)
                      : disabledFriends
                        ? ('campaign.warningPriorityRef' | translate)
                        : null
                  ">
                  <div class="template-item">
                    <div class="template-item-img">
                      @if (template.previewImages.length === 1) {
                        <img
                          onError="this.src='/assets/img/campaign/thumbnail-darkmode.png'"
                          [src]="template && template.previewImages[0]?.url"
                          alt="Image Title" />
                      }
                    </div>
                    <div class="template-item-name">
                      <span>{{ template.name }}</span>
                    </div>
                    <div class="template-item-tags">
                      @for (tag of template.tagsDetails; track tag) {
                        <div class="tag-item">
                          <span>{{ tag.name }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    }
  </div>
</div>
